import React, { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import classNames from 'classnames';
import UISpinner from 'Components/UIComponents/UISpinner';
import { useLtdTierGet } from 'Hooks/Billing';
import useIsMobile from 'Hooks/Common/useIsMobile';
import { LtdTier } from 'Interfaces/Billing';
import { planTypeToName } from 'Utils/formatters';
import { isNotEmpty } from 'Utils/functions';
import { selectLtdTier } from 'Utils/selectors';

import { shortLtdOptions } from '../common/planTableItems';

interface LifeTimeDealInfoBlockProps {
  ltdId: LtdTier['id'];
}

const LifeTimeDealInfoBlock = ({ ltdId }: LifeTimeDealInfoBlockProps) => {
  const isMobile = useIsMobile();

  const [getLtdTier, isGettingLtdTier] = useLtdTierGet();
  const currentLtd = useSelector(selectLtdTier);

  const shortLtdAdditionalOptions = useMemo(
    () =>
      shortLtdOptions.map(item =>
        item.name === 'Users'
          ? {
              ...item,
              value:
                currentLtd.teammatesLimit === -1
                  ? 'Unlimited'
                  : currentLtd.teammatesLimit,
            }
          : item,
      ),
    [currentLtd],
  );

  const handleGetLtdTier = useCallback(() => {
    getLtdTier({ ltdId });
  }, [getLtdTier, ltdId]);

  useEffect(() => {
    handleGetLtdTier();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isGettingLtdTier || !isNotEmpty(currentLtd)) {
    return (
      <UISpinner
        wrapperClassName="spinner--main__wrapper card-form__spinner"
        width={50}
        height={50}
      />
    );
  }

  return (
    <div className={classNames('billing__tier-wrapper', { mobile: isMobile })}>
      <span className="billing__tier-label">
        Signaturely + Prime Deals Lifetime Plans
      </span>
      <div className={classNames('billing__tier-container', { mobile: isMobile })}>
        <div className={classNames('billing__tier-left', { mobile: isMobile })}>
          <div className="billing__tier-left__title-container">
            <span className="billing__tier-left__title-container__title">
              {currentLtd.name}
            </span>
            <div className="billing__tier-left__title-container__plan-billet billing__current-plan">
              Current Plan
            </div>
          </div>
          <div className="billing__tier-left__plan-container">
            <span className="billing__tier-left__plan-container__plan-name">
              {planTypeToName[currentLtd.planType]} Plan <b>(${currentLtd.price})</b>
            </span>
          </div>
        </div>
        <div className={classNames('billing__tier-right', { mobile: isMobile })}>
          <div className="billing__tier-right__title">What&apos; included?</div>
          <ul>
            {shortLtdAdditionalOptions.map(option => (
              <li className="billing__tier-right__options-item" key={option.name}>
                <span className="option_value business">
                  {option['value']} {option['name']}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LifeTimeDealInfoBlock;
